module.exports = __webpack_public_path__ + "img/1950.9bd14f9f.svg";